import { SlideEvent, ReactSlideEvent, ReactTouchEvent } from './types';
import { safeAdd } from '@surveycake/utils';
import { safeMul } from '@surveycake/utils';

export function getHandlerSize(size: number) {
  return size * 3;
}

export function isTouchEvent(
  event: SlideEvent | ReactSlideEvent
): event is TouchEvent | ReactTouchEvent {
  const { touches } = event as TouchEvent | ReactTouchEvent;
  return !!(touches && touches.length);
}

export function getEventClientPosition(event: SlideEvent | ReactSlideEvent) {
  let x, y;

  if (isTouchEvent(event)) {
    x = event.touches[0].clientX;
    y = event.touches[0].clientY;
  } else {
    x = event.clientX;
    y = event.clientY;
  }

  return { x, y };
}

function boundValue(value: number, lower: number, upper: number) {
  if (value < lower) {
    return lower;
  } else if (value > upper) {
    return upper;
  }

  return value;
}

export function calculateValueByPosition(
  position: number,
  vertical: boolean,
  min: number,
  max: number,
  step: number,
  bound: number
) {
  const range = max - min;
  let ratio = boundValue(position, 0, bound) / bound;
  ratio = vertical ? 1 - ratio : ratio;
  const value = safeAdd(safeMul(Math.round((ratio * range) / step), step), min);

  return boundValue(value, min, max);
}

export function calculatePercentage(value: number, min: number, max: number) {
  return boundValue(((value - min!) / (max! - min!)) * 100, 0, 100);
}
